/* eslint-disable jsx-a11y/anchor-is-valid */
import AnimatedSnowImage from '../components/AnimatedSnowImage';
import GenericButton from '../components/button/GenericButton';
import { Terms } from '../components/footer-terms/Terms';

import '../index.css';
import './SubmittionScreen.css';

const SubmittionScreen = () => {
  return (
    <div className='submittion-page full-screen blue-bg'>
      <div className='submittion-container'>
        <AnimatedSnowImage />
        <img
          src='/assets/submittion-bg.png'
          alt='Snowman'
          width='100'
          className='submittion-image'
        />
        <div className='submittion-header'>
          <span className='text-gold submittion-title'>
            THANKS FOR SUBMITTING
          </span>
          <span className='submittion-subtitle'>
            You’ve been entered for a chance to win some Holiday scratch-offs.
            Winners will be notified by email beginning on Jan 6th, 2026.
          </span>
          <div className='video-container'>
            <img
              className='tickets-image'
              src='/assets/snowman-tickets.png'
              alt='Snowman'
              width='100%'
            />
            <iframe
              className='submittion-video'
              width='320'
              height='240'
              src='https://www.youtube.com/embed/-u2ppI-7OJM'
              title='YouTube video player'
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              allowFullScreen
            />
          </div>
          <div
            style={{
              position: 'relative',
              marginBottom: '70px'
            }}
          >
            <GenericButton
              page='https://nclottery.com/scratch-off'
              text='LEARN MORE'
            />
            <GenericButton page='/' text='PLAY AGAIN' />
          </div>
        </div>
        <div className='submittion-footer'>
          <div className='submittion-footer-content'>
            <img
              className='snow-image-2'
              src='/assets/snowman-snow-2.png'
              alt='Snowman'
              width='100%'
            />

            <img
              className='snow-image-1'
              src='/assets/snowman-snow-1.png'
              alt='Snowman'
              width='100%'
            />
            <div className='submittion-footer-buttons'>
              <Terms
                color='#0a1f55'
                showShareButtons
                shareButtonsRedirect={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmittionScreen;
